module.exports = __webpack_public_path__ + "img/logo.e610e6c7.png";